"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paths = void 0;
const TokenPaths = {
    createConnectionToken: '/v1/sockets/tokens',
};
exports.Paths = {
    v1: Object.assign({}, TokenPaths),
};
